import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import Button from '../../Button';
import FieldsList from '../../common/FieldsList';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { useSimpleForm } from '../../common/SimpleFormPopup/utils/useSimpleForm';
import { LOGIN_ERROR_CODES } from '../../../constants/errors';
import { useToggleFlag } from '../../../hocs/useToogleFlag';
import SimpleInfoPopup from '../../common/SimpleInfoPopup';
import styles from '../index.styles';
import { enhance } from './enhance';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { usePageView } from '../../../hocs/usePageView';

const FIELDS = [PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE];
const CUSTOM_FIELDS_STYLES = {
  [PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE]: cn(
    styles.labelField,
    styles.inputField,
  ),
};

const AuthSignupInvitation = ({
  errors,
  intl: { formatMessage },
  registrationUser,
}) => {
  const {
    handleFormChange,
    validateErrors,
    clearErrors,
    formState,
    isValid,
  } = useSimpleForm(FIELDS, FIELDS, errors);
  const [opened, openConfirm, closeConfirm] = useToggleFlag();

  usePageView('Sign Up Invitation');
  useEffect(() => {
    if (!isEmpty(errors)) {
      const code = get(errors, 'code');
      if (code === LOGIN_ERROR_CODES.INVITE_NOT_CONFIRMED) {
        openConfirm();
      }
    }
  }, [errors]);

  const handleClick = e => {
    e.preventDefault();
    clearErrors();

    const { emailOrPhone } = formState;

    registrationUser({
      user: {
        login: emailOrPhone,
      },
    });
  };

  return (
    <div className={cn(styles.formWrapper)}>
      <MetaHelmet title="pages.title.signupInvite" />

      <p className={styles.formTitle}>
        {formatMessage({ id: 'titles.signup' })}
      </p>
      <p className={styles.formText}>
        {`${formatMessage({
          id: 'auth.signup.invitationLinkDesc',
        })} ${formatMessage({ id: 'auth.expiredToken.text' })}`}
      </p>
      <FieldsList
        className={styles.fieldsList}
        fields={FIELDS}
        formState={formState}
        validateErrors={validateErrors}
        onChange={handleFormChange}
        initialData={formState}
      />

      <Button
        className={cn(styles.acceptBtn, 'db mb3 w-100 lh-copy')}
        color="primary"
        onClick={handleClick}
        disabled={!isValid}
      >
        {formatMessage({ id: 'common.invite' })}
      </Button>
      <SimpleInfoPopup
        icon="icon-plane"
        opened={opened}
        width="xsmall"
        messageId="auth.info.signUpInviteNotConfirmed"
        onClick={closeConfirm}
        withHeading={false}
        buttonTitleId="submit.expiredToken"
        mobileFullScreen={false}
      />
    </div>
  );
};

AuthSignupInvitation.propTypes = {
  errors: PropTypes.object,
  intl: PropTypes.object.isRequired,
  registrationUser: PropTypes.func.isRequired,
};

export default enhance(AuthSignupInvitation);



// WEBPACK FOOTER //
// ./src/components/Auth/AuthSignupInvitation/index.jsx